
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/egypt/contact-us",
      function () {
        return require("private-next-pages/egypt/contact-us.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/egypt/contact-us"])
      });
    }
  